import React, { createContext, useCallback, useContext, useMemo, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const ImportFileTransferContext = createContext({ pending: null, transfer: null, claim: () => null });

// Mounted with the authenticated session as its key: Files never cross users.
export function ImportFileTransferProvider({ children }) {
    const [pending, setPending] = useState(null);
    const pendingRef = useRef(null);
    const navigate = useNavigate();
    const transfer = useCallback((destination, file) => {
        const next = { destination, file };
        pendingRef.current = next;
        setPending(next);
        navigate(destination === 'watchlist' ? '/dashboard/watchlist' : '/dashboard/overview');
    }, [navigate]);
    const claim = useCallback((request) => {
        if (!request || pendingRef.current !== request) return null;
        pendingRef.current = null;
        setPending(null);
        return request.file;
    }, []);
    const value = useMemo(() => ({ pending, transfer, claim }), [pending, transfer, claim]);
    return <ImportFileTransferContext.Provider value={value}>{children}</ImportFileTransferContext.Provider>;
}

export const useImportFileTransfer = () => useContext(ImportFileTransferContext);
